import React from "react";

const Footer = () => {
    return (
        <div className="footer" style={{color: 'white'}}>
            <p >developed with <i class="fas fa-heart"></i> by technobyte</p>
        </div>
    );
};

export default Footer;